"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.product = void 0;
const axios_class_1 = require("./axios.class");
const index_1 = require("./index");
class Product {
    async getHistory(productId) {
        const { data } = await axios_class_1.axios.get(`/v1/products/getProductHistory/${productId}`);
        return data;
    }
    async getUserCollections({ filters = {}, currentPage = 0, perPage = 10, signal, getAll, clientId }) {
        // signal is used by the front to cancel a pending request
        const { data } = await axios_class_1.axios.post(`/v1/products/collections/${perPage}/${currentPage}`, {
            filters,
            getAll,
            clientId
        }, { signal });
        return data;
    }
    async productsFromCollection(collectionId, filters = {}, currentPage = 0, perPage = 10, signal) {
        const { data } = await axios_class_1.axios.post(`/v1/products/${collectionId}/${perPage}/${currentPage}`, {
            filters
        }, { signal });
        return data;
    }
    async getProductsFromCollection(collectionId) {
        const { data } = await axios_class_1.axios.post(`/v1/products/${collectionId}`);
        return data;
    }
    async getProductsFromClientId({ page, perPage, nftCollections, } = {}) {
        const queryParams = {
            page: page,
            perPage: perPage,
            nftCollections: nftCollections === null || nftCollections === void 0 ? void 0 : nftCollections.join(","),
        };
        const { data } = await axios_class_1.axios.get((0, index_1.buildURL)(`/v1/products/client`, queryParams));
        return data;
    }
    async getProductsFromCollectionIdParsed(collectionId) {
        const { data } = await axios_class_1.axios.post(`/v1/products/${collectionId}/parsed`);
        return data;
    }
    getProductsForSale(marketplaceId, collectionId, filters = {}, currentPage = 0, perPage = 10) {
        return axios_class_1.axios.get(`/v1/marketplace/${marketplaceId}/products/forSale?nftCollectionId=${collectionId}&perPage=${perPage}&currentPage=${currentPage}`);
    }
    productById(id) {
        return axios_class_1.axios.get(`/v1/products/${id}`);
    }
    /* DAN / Market: Choose Nft before entering phonenNumber (no user yet available) */
    chooseNft({ collectionId, productId, marketplaceId }) {
        return axios_class_1.axios.post(`/v1/marketplace/${marketplaceId}/products/choose`, {
            collectionId,
            productId
        });
    }
    reserveNft(collectionId) {
        return axios_class_1.axios.post(`/v1/products/reserve/${collectionId}`);
    }
    reserveNftV2({ collectionId, address, recaptchaToken, marketplaceId, productId = null }) {
        return axios_class_1.axios.post(`/v1/marketplace/${marketplaceId}/products/reserve`, {
            collectionId,
            address,
            recaptchaToken,
            productId,
        });
    }
    getUserTotalProductsCount() {
        return axios_class_1.axios.get(`/v1/products/count`);
    }
    makeOppositionOnNft(productId, comment) {
        return axios_class_1.axios.post(`/products/makeOpposition/${productId}`, { details: comment });
    }
    withdrawOpposition(productId, comment) {
        return axios_class_1.axios.post(`/products/withdrawOpposition/${productId}`, { details: comment });
    }
    getBoughtProduct(encryptedData, marketplaceId) {
        return axios_class_1.axios.post(`/v1/marketplace/${marketplaceId}/products/market`, { encryptedData });
    }
    cancelReservedNft(encryptedProductId, marketplaceId) {
        return axios_class_1.axios.post(`/v1/marketplace/${marketplaceId}/products/cancel`, { encryptedProductId });
    }
    addImageToProductGallery(productId, imageData) {
        const formData = new FormData();
        formData.append('title', imageData.title);
        formData.append('extension', imageData.extension);
        formData.append('image', imageData.image);
        formData.append('isPublic', imageData.isPublic.toString());
        return axios_class_1.axios.post(`/v1/products/addImage/${productId}`, formData, { headers: { contentType: 'multipart/form-data' } });
    }
    getProductImagesGallery(productId) {
        return axios_class_1.axios.get(`/v1/products/images/${productId}`);
    }
    updateImagePrivacy(productId, imageId, isImagePublic) {
        return axios_class_1.axios.post(`/v1/products/updateImage/${productId}/${imageId}/${isImagePublic}`);
    }
    deleteImage(productId, imageId) {
        return axios_class_1.axios.delete(`/v1/products/deleteImage/${productId}/${imageId}`);
    }
    /**
     * @Deprecated
     */
    async requestRepair(productId, { savStore, details }) {
        try {
            await axios_class_1.axios.post(`/v1/products/${productId}/repair`, {
                savStore,
                details
            });
            return true;
        }
        catch (_a) {
            return false;
        }
    }
    /**
     * @Deprecated
     */
    async updateProductRepairState(productId, state) {
        const { data } = await axios_class_1.axios.post(`/v1/products/${productId}/repair/${state}`);
        return data;
    }
    async requestOrUpdateRepair(productId, { savStore, details }) {
        try {
            const { data } = await axios_class_1.axios.post(`/v2/products/${productId}/repair`, {
                savStore,
                details
            });
            return data;
        }
        catch (_a) {
            return false;
        }
    }
    async getProductRepairRequest(productId, repairId) {
        const { data } = await axios_class_1.axios.get(`/v1/products/${productId}/repair/${repairId}`);
        return data;
    }
    async getImage(productId, eventId) {
        const { data } = await axios_class_1.axios.get(`/v1/products/images/${productId}/${eventId}`);
        return data;
    }
    async cancelRepairRequest(productId, repairId) {
        const { data } = await axios_class_1.axios.delete(`/v1/products/${productId}/repair/${repairId}`);
        return data;
    }
    /* to get most recent products from all collections */
    async getProducts({ perPage = 10, currentPage = 0, searchedName, ableToSend, clientId, signal }) {
        const { data } = await axios_class_1.axios.post(`/v1/products/${perPage}/${currentPage}`, { filters: { name: searchedName, ableToSend }, clientId }, { signal });
        return data;
    }
    async getLuckyWheelResult(collectionId, marketplaceId) {
        const { data } = await axios_class_1.axios.post(`/v1/marketplace/${marketplaceId}/products/getLuckyWheelResult`, {
            collectionId
        });
        return data;
    }
    async getProperties(nftCollections) {
        const { data } = await axios_class_1.axios.get((0, index_1.buildURL)(`/v1/products/properties`, {
            nftCollections: nftCollections === null || nftCollections === void 0 ? void 0 : nftCollections.join(','),
        }));
        return data;
    }
}
exports.product = new Product();
